import { SR_API_ACTION_APARTMENT_LOCATOR_GET_UNSEEN_FEED_ACTIVITY_COUNT } from 'api/actionTypes';

export default async function getUnseenFeedActivityCount(
  { state, apiClient },
  apartmentLocatorUserId,
) {
  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_LOCATOR_GET_UNSEEN_FEED_ACTIVITY_COUNT,
    state: state,
    payload: {
      apartmentLocatorUserId: apartmentLocatorUserId,
    },
    onSuccess(unseenFeedActivityCount) {
      state.set(['apartmentLocator', 'unseenFeedActivityCount'], unseenFeedActivityCount);
    },
  });
}
